import { ensureDefined } from '@avantia/client-and-server-utilities';
import { CheckBoxListControl, RadioListControl } from '../../../engineClient/components/formControls/standard';
import { getAnswersFromAnswerMap } from '../../../engineClient/tools/clientAndServerUtilities';
import { HpClientQuestionData, HpClientQuestionLookupItemMap, HpInputControlProps } from '../../../engineClient/types';
import { questionIds } from '../../../types/questionConstants';
import { HpClaimsQuestionSetPageProps } from '../../questionSetForm/questionSetPageTypes';

export interface SpecifiedItemsCustomControlProps extends HpInputControlProps {
  customData: SpecifiedItemsCustomData;
}

interface SpecifiedItemsCustomData {
  somethingElseLookupOption: HpClientQuestionLookupItemMap;
  canRemoveDamagedSpecifiedItem?: boolean;
}

export function SpecifiedItemsCustomControl(buttonListProps: SpecifiedItemsCustomControlProps): JSX.Element | null {
  const { question, answers, pageProps } = buttonListProps;
  const { policies } = pageProps as HpClaimsQuestionSetPageProps;
  ensureDefined(policies, 'policies');
  const { isMultiSelect } = question;
  const data = question.data as HpClientQuestionData;
  const { customData } = data as HpClientQuestionData;
  ensureDefined(customData, 'customData');
  const policyReference = answers[questionIds.policyInstance].customer as string;
  const selectedPolicy = policies[policyReference];
  ensureDefined(selectedPolicy, 'selectedPolicy');

  const { somethingElseLookupOption, canRemoveDamagedSpecifiedItem } =
    customData as unknown as SpecifiedItemsCustomData;
  let updatedData: HpClientQuestionData | null = null;
  let lookup: HpClientQuestionLookupItemMap = {};

  let items = selectedPolicy.specifiedItems;
  if (!items.length) {
    return null;
  }

  if (canRemoveDamagedSpecifiedItem) {
    const { specifiedItems } = getAnswersFromAnswerMap({
      answers,
      keys: ['specifiedItems'],
      options: { returnAnyAnswerType: true },
      productId: pageProps.productId
    });

    items = items.filter((i) => i.description !== specifiedItems);
  }

  for (const item of items) {
    const { description } = item;
    lookup[description] = { text: description }; // TODO - Add description from value (subtext)
  }

  if (Object.keys(lookup).length) {
    if (somethingElseLookupOption) {
      lookup = { ...lookup, ...somethingElseLookupOption };
    }

    updatedData = {
      ...data,
      lookup: { ...lookup }
    };

    if (isMultiSelect) {
      return <CheckBoxListControl {...buttonListProps} data={updatedData || (data as HpClientQuestionData)} />;
    }

    return <RadioListControl {...buttonListProps} data={updatedData || (data as HpClientQuestionData)} />;
  }

  return null;
}
